"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("react"));
var _Box = _interopRequireDefault(require("@kiwicom/orbit-components/lib/Box"));
var _TextLink = _interopRequireDefault(require("@kiwicom/orbit-components/lib/TextLink"));
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const SidePanelTextLink = _ref => {
  let {
    children,
    href,
    iconLeft,
    rel = "nofollow",
    onClick,
    setMinHeight = false
  } = _ref;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Box.default, {
    display: "flex",
    className: setMinHeight ? "min-h-[32px]" : "",
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_TextLink.default, {
      noUnderline: true,
      rel: rel,
      type: "secondary",
      href: href,
      iconLeft: iconLeft,
      onClick: onClick,
      children: children
    })
  });
};
var _default = exports.default = SidePanelTextLink;